import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getListHistory, getAllHistory, HistoryEvent } from '../repository/listRepository';

export const HistoryView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [events, setEvents] = useState<HistoryEvent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = id ? getListHistory(id) : getAllHistory();
    fetch.then(setEvents).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">{id ? 'List History' : 'Recent Activity'}</h1>
        {id && <Link to={`/lists/${id}`} className="btn btn-sm">Back to list</Link>}
      </div>

      {events.length === 0 ? (
        <div className="empty-state"><p>No history yet.</p></div>
      ) : (
        <div className="history-list">
          {events.map(event => (
            <div key={event.timestamp_event_id} className="history-event">
              <div className="history-description">
                <span className="history-type">{event.event_type.replace(/_/g, ' ')}</span>
                {event.description}
              </div>
              <div className="history-meta">
                {new Date(event.timestamp).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
